import { useVieConfig } from '@hmpu/powerups.vie.hooks.use-vie-config';
import { usePageConfig } from '@hmpu/powerups.config.page.provider';

export const usePageNavigation = () => {
  const { currentPage } = usePageConfig();
  const { goToPage } = useVieConfig();

  const transitionKeyFrames = [
    { opacity: '0', offset: 0 },
    { opacity: '0', offset: 0.5 },
    { opacity: '1', offset: 1 },
  ];

  const goToPageWithTransition = (targetPage: string | number) => {
    const mainEl: HTMLDivElement = document.querySelector('.game-wrapper')!;
    mainEl.animate(transitionKeyFrames, {
      duration: 1000,
      easing: 'ease',
    });

    goToPage(targetPage);
  };

  const goToNextPageWithTransition = () => {
    goToPageWithTransition(currentPage + 1);
  };
  const goToPrevPageWithTransition = () => {
    goToPageWithTransition(currentPage - 1);
  };

  return {
    goToPage: goToPageWithTransition,
    goToNextPage: goToNextPageWithTransition,
    goToPrevPage: goToPrevPageWithTransition,
  };
};
